/* =====================================
	 4. AXIS LABEL (Rotated)
	 ===================================== */
import React from "react";
import { EllipsisText } from "./EllipsisText";

interface IAxisLabelProps {
	label: string;
	orientation?: "vertical" | "horizontal";
	className?: string;
	/** Vertical only: available height in px (becomes the text's max-width before rotation) */
	maxHeight?: number;
}

export const AxisLabel: React.FC<IAxisLabelProps> = ({
	label,
	orientation = "vertical",
	className = "",
	maxHeight,
}) => {
	if (orientation === "horizontal") {
		return (
			<EllipsisText
				text={label}
				maxLines={1}
				lineHeight={16}
				className={`text-[12px] text-[#403C45] font-normal text-center ${className}`}
			/>
		);
	}

	const constrainedWidth = maxHeight ?? 120;

	return (
		<div
			className={`w-[20px] flex items-center justify-center ${className}`}
			style={{ height: constrainedWidth }}
		>
			<div
				className="rotate-[-90deg]"
				style={{ width: constrainedWidth }}
			>
				<EllipsisText
					text={label}
					maxLines={1}
					lineHeight={16}
					className="text-[12px] text-[#403C45] font-normal tracking-wide text-center"
					width={constrainedWidth}
					tooltipPlacement="right"
				/>
			</div>
		</div>
	);
};